import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router/client';
import store from './store';

import './assets/css/common.less';
import './assets/font/iconfont.css';
// import './elementui-css/index.css'
import ElementUI from 'element-ui';
// import "./assets/elementui-css/index.css";
Vue.config.productionTip = false;
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js